import React from 'react';
import type { LogoMakerIntegration } from '../../context/LogoMakerContext';
import LogoMakerProviders from '../../context/LogoMakerContext/LogoMakerProviders';
import { LoggedOutLogoMaker, type LoggedOutLogoMakerProps } from './LoggedOutLogoMaker';

export interface ModernLoggedOutLogoMakerProps extends LoggedOutLogoMakerProps {
    showBackButton?: boolean;
    integration?: LogoMakerIntegration;
    isTransparent?: boolean;
    isSticky?: boolean;
}

export const ModernLoggedOutLogoMaker = ({
    showSeoLinks,
    showJoinLink,
    showBackButton,
    integration,
    isTransparent,
    isSticky,
}: ModernLoggedOutLogoMakerProps) => (
    <LogoMakerProviders
        showBackButton={showBackButton}
        integration={integration}
        isTransparent={isTransparent}
        isSticky={isSticky}
    >
        <LoggedOutLogoMaker showSeoLinks={showSeoLinks} showJoinLink={showJoinLink} />
    </LogoMakerProviders>
);

export default ModernLoggedOutLogoMaker;
